






































































































































import Vue from 'vue'
import { cloneDeep, isEqual } from 'lodash'

export default Vue.extend({
  name: 'RtsDataTable',

  props: {
    options: {
      type: Object,
      required: true
    },
    // TODO: refactor as v-model when upgrade to Vue3
    pagination: {
      type: Object,
      default: () => ({
        currentPage: 1,
        perPage: 15,
        hasNextPage: false
      })
    },
    value: {
      type: Array,
      default: () => []
    },
    currentExpandedRows: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      active: {
        pagination: {
          perPage: this.options['items-per-page'] || 5,
          currentPage: 1,
          hasNextPage: false
        }
      },
      selectedRows: [],
      expandedRows: [],
      currentOptions: {},
      paginationOption: {
        perPage: this.options['items-per-page-options'] || [5, 10, 15, 30, 50, 75, 100]
      }
    }
  },

  computed: {
    tableOptions(): { [name: string]: any } {
      const options = cloneDeep(this.options)
      options.headers = options.headers.map(header => ({
        ...header,
        sortable: false
      }))

      const perPage = this.options.usePagination ? this.active.pagination.perPage : this.options['items-per-page']
      
      // 處理 Vuetify DataTable 原生分頁選項
      const footerProps = {}
      if (this.options['items-per-page-options']) {
        footerProps['items-per-page-options'] = this.options['items-per-page-options']
      }

      return {
        ...options,
        'hide-default-footer': this.options.usePagination || this.options['hide-default-footer'],
        'items-per-page': perPage,
        'footer-props': footerProps,
        'fixed-header': !!(this.customProps?.bodyMaxHeight || this.customProps?.minHeight)
      }
    },

    customProps(): { [name: string]: any } | null {
      return this.options.custom || null
    }
  },

  watch: {
    value: {
      handler(val) {
        this.selectedRows = val
      },
      deep: true,
      immediate: true
    },

    selectedRows: {
      handler(newVal, oldVal) {
        const isSame = isEqual(newVal, oldVal)

        if (!isSame) {
          this.$emit('update:selected', newVal)
        }
      },
      deep: true
    },

    currentExpandedRows: {
      handler(rows) {
        this.expandedRows = rows
      },
      immediate: true
    },

    expandedRows: {
      handler(rows) {
        this.$emit('update:expanded', rows)
      }
    },

    pagination: {
      handler(val) {
        this.active.pagination = { ...this.pagination }
      },
      deep: true,
      immediate: true
    },

    'active.pagination': {
      handler(val) {
        this.$emit('update:pagination', val)
      },
      deep: true
    },
    'options.loading': {
      handler(val) {
        //Hack，因為vuetify使用loading時會導致selection在前端畫面被清掉，用此方式重新顯示
        this.selectedRows = this.selectedRows.map(v => v)
      },
      deep: true
    }
  },

  methods: {
    selectedAll(payload: { items: Array<any>; value: boolean }) {
      const { items, value: isAppend } = payload

      items.forEach(item => {
        const index = (this.selectedRows as Array<any>).findIndex(row => row.id === item.id)
        const isExists = index >= 0

        if (isExists && !isAppend) this.selectedRows.splice(index, 1)
        if (!isExists && isAppend) (this.selectedRows as Array<any>).push(item)
      })

      this.$emit('update:selected', this.selectedRows)
    },

    updateOptions(val) {
      this.$emit('update:options', val)
    }
  }
})
